import TabbedPage from 'components/tabbed-page';
import { useCurrentRoles } from 'hooks/use-current-roles';
import TemplatesTab from './templates-tab';
import SettingsTab from './settings-tab';
import BulkTab from './bulk-tab';

/** Văn mẫu (ADMIN + MOD) · Cài đặt và Mở kênh hàng loạt (chỉ ADMIN). */
const SupportManagePage = () => {
  const { isAdmin, loaded } = useCurrentRoles();
  return (
    <TabbedPage
      title="Văn mẫu & cài đặt hỗ trợ"
      tabs={[
        { key: 'templates', label: 'Văn mẫu', render: () => <TemplatesTab /> },
        { key: 'settings', label: 'Cài đặt', render: () => <SettingsTab />, hidden: loaded && !isAdmin },
        { key: 'bulk', label: 'Mở kênh hàng loạt', render: () => <BulkTab />, hidden: loaded && !isAdmin },
      ]}
    />
  );
};

export default SupportManagePage;
